module.exports = __webpack_public_path__ + "static/media/BISON.28dfbd3e.png";